module.exports = __webpack_public_path__ + "static/media/cf.037865b5.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/cf.svg
// module id = 616
// module chunks = 0